// libs
import React from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";

// utils
import formatDatesSet from "../../Utils/Date/Dateset";

const SignalGraph = (props) => {
	const { t, i18n } = useTranslation();

	const { data } = props;

	const mapSeries = () => {
		return [{
			name: t("tanks.details.data.signal.graph.signal"),
			type: "area",
			data: data.map( (datum) => datum.signalStrength),
		}];
	}

	const mapDates = () => {
		return data.map( (datum) => {
			return formatDatesSet(datum.startDate,datum.endDate,i18n);
		})
	};

	const labelLegend = [t("tanks.details.data.signal.graph.signal")];

	return (
		<>
			<ReactApexChart
				options={{
					chart: {
						height: 300,
						width: "100%",
						type: "area",
						stacked: true,
						zoom: { enabled: false },
						toolbar: { show: false },
					},
					dataLabels: {
						enabled: false,
					},
					stroke: {
						width: 2
					},
					fill: {
						type: 'gradient'
					},
					colors: [
						"#55B545"
					],
					xaxis: {
						type: "category",
						tooltip: { enabled: false },
						categories: mapDates()
					},
					yaxis:
						[
							{
								seriesName: [
									t("tanks.details.data.signal.graph.signal"),
								],
								min: 0,
								max: 100,
								axisTicks: {
									show: true,
									offsetX: 0,
								},
								axisBorder: {
									show: true,
									color: "#DCDCDC",
									offsetX: 0,
								},
								labels: {
									style: { colors: "#333333" },
									formatter: function (val) {
										return Math.round(val) + " %";
									}
								},
								title: {
									text: t("tanks.details.data.signal.graph.yaxis_title"),
									style: { color: "#333333" },
								},
								tooltip: { enabled: false },
							},
						],
					tooltip: {
						enabledOnSeries: [0,1],
						fixed: {
							enabled: false,
							position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
							offsetY: 0,
							offsetX: 0,
						},
					},
					legend: {
						horizontalAlign: "left",
						customLegendItems: labelLegend,
						offsetX: 40,
					},
				}}
				series={ mapSeries() }
				type="area"
				height={350}
			/>
		</>
	);
};

export default SignalGraph;
